// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsLinks_PendingRefundsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/links/pending_refunds/{recebimento_id}
 *
 * Returns the pending refund-request status for a recebimento, plus the full
 * list of refund requests recorded for it.
 *
 * Controller source: Links::pending_refunds() in controllers/subaccounts/links.php
 */
import type { SubaccountsLinks_PendingRefundRequestRow } from './SubaccountsLinks_PendingRefundRequestRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface SubaccountsLinks_PendingRefundsResponseDados {
has_pending: boolean
pending_request: SubaccountsLinks_PendingRefundRequestRow | null
all_requests: SubaccountsLinks_PendingRefundRequestRow[]
}

export type SubaccountsLinks_PendingRefundsResponse = ApiResponse<SubaccountsLinks_PendingRefundsResponseDados>;

registerResponseContract('SubaccountsLinks_PendingRefundsResponse', {
  has_pending:  { type: 'boolean', required: true },
  pending_request: {
    type: 'object',
    required: false,
    fields: {
      id:                      { type: 'number',  required: true },
      recebimento_id:          { type: 'number',  required: true },
      payment_link_id:         { type: 'number',  required: true },
      requested_amount:        { type: 'number',  required: true },
      requested_at:            { type: 'string',  required: true },
      requested_by_user_id:    { type: 'string',  required: true },
      description:             { type: 'string',  required: false },
      status:                  { type: 'string',  required: true },
      confirmed_at:            { type: 'string',  required: false },
      provider_refund_id:      { type: 'string',  required: false },
      negative_recebimento_id: { type: 'number',  required: false },
      failed_at:               { type: 'string',  required: false },
      failure_reason:          { type: 'string',  required: false },
      cancelled_at:            { type: 'string',  required: false },
      cancelled_by_user_id:    { type: 'string',  required: false },
      created_at:              { type: 'string',  required: false },
      updated_at:              { type: 'string',  required: false },
    },
  },
  all_requests: {
    type: 'array',
    required: true,
    items: {
      id:                      { type: 'number',  required: true },
      recebimento_id:          { type: 'number',  required: true },
      payment_link_id:         { type: 'number',  required: true },
      requested_amount:        { type: 'number',  required: true },
      requested_at:            { type: 'string',  required: true },
      requested_by_user_id:    { type: 'string',  required: true },
      description:             { type: 'string',  required: false },
      status:                  { type: 'string',  required: true },
      confirmed_at:            { type: 'string',  required: false },
      provider_refund_id:      { type: 'string',  required: false },
      negative_recebimento_id: { type: 'number',  required: false },
      failed_at:               { type: 'string',  required: false },
      failure_reason:          { type: 'string',  required: false },
      cancelled_at:            { type: 'string',  required: false },
      cancelled_by_user_id:    { type: 'string',  required: false },
      created_at:              { type: 'string',  required: false },
      updated_at:              { type: 'string',  required: false },
    },
  },
})
